export enum FrequencyPeriodEnum {
    PerEvent = 0,
    Daily,
    Weekly,
    Monthly,
    None,
}
